document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.link--more').forEach(e => {
        e.addEventListener('click', (e) => {
            e.preventDefault();
            e.target.previousElementSibling.classList.add('show');
            e.target.remove();
        });
    });

    document.querySelectorAll('.faq menu li');

    document.addEventListener('lazybeforeunveil', function (e) {
        const bg = e.target.getAttribute('data-bg');
        if (bg) {
            e.target.style.backgroundImage = 'url(' + bg + ')';
        }
    });
});

(function () {
    if (typeof EventTarget !== "undefined") {
        let func = EventTarget.prototype.addEventListener;
        EventTarget.prototype.addEventListener = function (type, fn, capture) {
            this.func = func;
            if(typeof capture !== "boolean"){
                capture = capture || {};
                capture.passive = false;
            }
            this.func(type, fn, capture);
        };
    };
}());

window.width = () => {
    let w = window,
        d = document,
        e = d.documentElement,
        g = d.getElementsByTagName('body')[0];

    return w.innerWidth || e.clientWidth || g.clientWidth;
}

window.deliveryServiceName = (serviceId) => {
    let deliveryServices = window.assets.deliveryServices || [];

    let index = deliveryServices.map(service => service.id).indexOf(serviceId);

    return index !== -1 ? deliveryServices[index].name : '';
};

window.isVisible = (el) => {
    let rect = el.getBoundingClientRect(),
        vWidth = window.innerWidth || document.documentElement.clientWidth,
        vHeight = window.innerHeight || document.documentElement.clientHeight,
        efp = (x, y) => {
            return document.elementFromPoint(x, y)
        };

    // Return false if it's not in the viewport
    if (rect.right < 0 || rect.bottom < 0
        || rect.left > vWidth || rect.top > vHeight)
        return false;

    // Return true if any of its four corners are visible
    return (
        el.contains(efp(rect.left, rect.top))
        || el.contains(efp(rect.right, rect.top))
        || el.contains(efp(rect.right, rect.bottom))
        || el.contains(efp(rect.left, rect.bottom))
    );
}

(function (ELEMENT) {
    ELEMENT.matches = ELEMENT.matches || ELEMENT.mozMatchesSelector || ELEMENT.msMatchesSelector || ELEMENT.oMatchesSelector || ELEMENT.webkitMatchesSelector;
    ELEMENT.closest = ELEMENT.closest || function closest(selector) {
        if (!this) return null;
        if (this.matches(selector)) return this;
        if (!this.parentElement) {
            return null
        } else return this.parentElement.closest(selector)
    };
}(Element.prototype));

const tabToggle = () => {
    document.addEventListener('click', (e) => {
        const tabs = document.querySelectorAll("[role='tab']"),
            tabPanels = document.querySelectorAll("[role='tabpanel']"),
            role = e.target.getAttribute('role'),
            href = e.target.getAttribute('href');

        if (role === 'tab' && tabs.length && tabPanels.length && href) {
            const tabPanelId = href.substring(1);

            tabs.forEach(tab => {
                if (tab.classList.contains('show')) {
                    tab.classList.remove('show');
                }
                if (tab.classList.contains('active')) {
                    tab.classList.remove('active');
                }
            });
            tabPanels.forEach(tabPanel => {
                if (tabPanel.classList.contains('show')) {
                    tabPanel.classList.remove('show');
                }
                if (tabPanel.classList.contains('active')) {
                    tabPanel.classList.remove('active');
                }
            });
            e.target.classList.add('show', 'active');
            document.getElementById(tabPanelId).classList.add('show', 'active');
        }
    });
}

tabToggle();

window.certs = async () => {
    let oStore = await cadesplugin.CreateObjectAsync("CAdESCOM.Store");

    if (!oStore) {
        throw new Error("Ошибка при создании хранилища");
    }
    await oStore.Open();

    let certCnt = 0;
    let certs = {};

    try {
        certs = await oStore.Certificates;
        certCnt = await certs.Count;
    } catch (e) {
        throw new Error("Ошибка при получении Certificates или Count: " + cadesplugin.getLastError(e));
    }

    let certificates = [];

    for (let i = 1; i <= certCnt; i++) {

        let cert = {};

        try {
            cert = await certs.Item(i);
        } catch (e) {
            throw new Error("Ошибка при перечислении сертификатов: " + cadesplugin.getLastError(e));
        }

        let today = new Date();
        today.setHours(0, 0, 0, 0);

        let ValidToDate = new Date(await cert.ValidToDate);
        let validFromDate = new Date(await cert.ValidFromDate);
        let validToDate = ValidToDate;
        let SubjectName = await cert.SubjectName;

        validFromDate = validFromDate.getDate() + '.' + validFromDate.getMonth() + '.' + validFromDate.getFullYear();
        validToDate = validToDate.getDate() + '.' + validToDate.getMonth() + '.' + validToDate.getFullYear();

        let name = SubjectName.split(', ');

        if (ValidToDate > today) {
            certificates.push({
                from_date: validFromDate,
                to_date: validToDate,
                name: name[0],
                key: encodeURI(SubjectName),
            });
        }
    }
    return certificates;
}

function scrollToLetter () {
    if (window.location.hash) {
        let hash = decodeURI(window.location.hash.substring(1));

        if ((hash.length !== 1) && (hash !== 'А-Я') && (hash !== '0-9')) {
            return
        }

        let offsetTop;

        if (window.width() < 991) {
            offsetTop = 105
        } else {
            offsetTop = 125
        }

        window.scrollTo({
            top: document.getElementById('letter-' + hash).offsetTop - offsetTop,
            behavior: 'smooth'
        })
    }
}

window.onload = scrollToLetter;
window.onhashchange = scrollToLetter;
document.addEventListener('DOMContentLoaded', function() {
    let windowOffsetY = window.pageYOffset;
    const pageHeader = document.querySelector('.brands .page-header');

    if (pageHeader) {
        const sticked = pageHeader.classList.contains('sticked');

        if (windowOffsetY > 213 && !sticked) {
            pageHeader.classList.add('sticked');
        } else if (windowOffsetY < 213) {
            pageHeader.classList.remove('sticked');
        }
    }
});

window.firstToUpper = s => s && String(s[0]).toUpperCase() + String(s).slice(1);



